import { Router } from "@angular/router";
import { Injectable, inject } from "@angular/core";
import { map } from "rxjs/operators";

import { HomeModel } from "./home.model";

@Injectable()
export class HomeGuard {
	private readonly router = inject(Router);
	private readonly homeModel = inject(HomeModel);

	canActivate() {
		return this.homeModel.lastActiveRoute$.pipe(
			map((lastActiveRoute) => this.router.createUrlTree([lastActiveRoute || "/home/residents"])),
		);
	}
}
